<template>
  <div>
    <DataTable
      :title="getTitle"
      :show_delete="false"
      :show_edit="false"
      :is_createable="false"
      :filters="filters"
      :sorters="sorters"
      :fields="fields"
      :response="data"
      :show_header_filter="false"
      :operations="operations"
      @info="showStatInfo"
      />
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'

export default {
  name: 'TimeExeeded',
  components: {
    DataTable
  },
  data () {
    return {
      fields: [
        {
          name: 'created_at',
          value: 'created_at',
          is_time: true
        },
        {
          name: 'title',
          value: 'title'
        },
        {
          name: 'owner',
          value: 'owner',
          component: 'TableCellOwner'
        },
        {
          name: 'content',
          value: 'content',
          component: 'AlertContent'
        },
        {
          name: 'resource',
          value: 'resources',
          component: 'AlertResourceCell'
        }
      ],
      sorters: [
        {
          designator: 'owner',
          value: '-owner'
        },
        {
          designator: 'created_at',
          value: '-created_at'
        }
      ],
      filters: [
        {
          type: 'single',
          designator: 'owner',
          options: this.dropdownAdmins
        }
      ],
      unique_buttons: [],
      schedule_of_the_day: [],
      interval: {},
      th_filters: {},
      data: [],
      working_th_searches: [],
      operations: [{ name: 'info', icon: '/info.svg' }]
    }
  },
  computed: {
    getTitle () {
      return 'חריגות זמנים'
    },
    ...mapGetters('admins', ['dropdownAdmins'])
  },
  watch: {
    dropdownAdmins (oldValue, newValue) {
      this.filters.forEach((filter) => {
        if (filter.designator === 'owner') {
          filter.options = newValue
        }
      })
    }
  },
  created () {
    this.getStats()
    this.fetchAll()
    document.title = this.getTitle
  },
  methods: {
    getStats () {
      this.$network_utils
        .getStats({
          designator: 'time_exceeded_alert',
          owner: this.$route.query.owner,
          sort: this.$route.query.sort,
          per: 100,
          page: this.$route.query.page || 1
        })
        .then((response) => {
          this.data = response.map(stat => {
            const r = new RegExp('.+(?=זמן בפועל:)', 'gs')
            const dirtyText = stat.content.replace(r, '').split('\n')
            return { ...stat, content: `${dirtyText[0]}\n<strong style="background: yellow">${dirtyText.slice(1).join('\n')}</strong>` }
          })
        })
    },
    showStatInfo (data) {
      if (!data.owner) {
        alert('Sorry, no owner exist for this alert.')
        return
      }
      this.create({
        designator: 'stat-form-modal',
        component_name: 'ModalAdminStats',
        modal_title: `${data.owner} stat's`,
        props: {
          initialStat: data
        }
      })
    },
    ...mapActions('admins', ['fetchAll']),
    ...mapMutations('modals', ['create'])
  }
}
</script>
